import React from 'react';
import Button from '@mui/material/Button';
import GoogleIcon from '@mui/icons-material/Google'; // Import Google icon

function GoogleSignInButton({redirectToGoogleOAuth}) {
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<GoogleIcon />} // Add the Google icon
      onClick={redirectToGoogleOAuth}
      style={{ backgroundColor: '#4285F4', color: '#fff' }} // Custom Google colors
    >
      Sign in with Google
    </Button>
  );
}

export default GoogleSignInButton;